import { ConditionalMandatory } from '../types/ViewModel/ConditionalMandatory';
import { ConditionalMandatoryBM } from '../types/BusinessModel/ConditionalMandatoryBM';

export class ConditionalMandatoryFactory {
    constructor() {}

    public newConditionalMandatoryArray(conditionalMandatoryList: ConditionalMandatoryBM[]): ConditionalMandatory[] {
        const conditionalMandatoryArray: ConditionalMandatory[] = [];
        if (conditionalMandatoryList && conditionalMandatoryList.length > 0) {
            conditionalMandatoryList.map((cmItem) => {
                conditionalMandatoryArray.push(this.createNewConditionalMandatoryItem(cmItem));
            });
        }
        return conditionalMandatoryArray;
    }

    private createNewConditionalMandatoryItem(item: ConditionalMandatoryBM): ConditionalMandatory {
        return new ConditionalMandatory(item.conditionalMandatoryId, item.conditionalMandatoryIdentity, item.eventTypeGroupId);
    }
}
